module.exports = "<div class=\"documentation-root\"></div>\r\n"